module.exports = __webpack_public_path__ + "static/media/heart.4af99c97.png";